import { createReducer } from '@reduxjs/toolkit';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';
import startsWith from 'lodash/startsWith';
import isEmpty from 'lodash/isEmpty';

import { ActionSuccessType, INIT_CUSTOM_PAGE_CONTENTS, GET_CONTENTS, ActionClearType } from 'constants/redux-actions';

const initState = {};

const reduceContentsSite = (contents, initData) =>
  reduce(
    contents,
    (res, content) => (content.visible ? { ...res, [content.key]: content } : omit(res, [content.key])),
    initData,
  );

const clearContents = (prevState, action) => {
  const clearPrefixKey = get(action, ['payload', 'prefixKey']);

  if (!isEmpty(clearPrefixKey)) {
    return omitBy(prevState, (_, key) => startsWith(key, `${clearPrefixKey}.`));
  } else {
    return prevState;
  }
};

const getContentsFromApi = (prevState, action) => {
  const contents = get(action, 'payload.data', []);

  const updatedState = clearContents(prevState, action);

  return reduceContentsSite(contents, updatedState);
};

const contentsSiteReducer = createReducer(initState, {
  [ActionSuccessType(GET_CONTENTS)]: getContentsFromApi,
  [INIT_CUSTOM_PAGE_CONTENTS]: (prevState, action) => reduceContentsSite(action.payload, prevState),
  [ActionClearType(GET_CONTENTS)]: clearContents,
});

export default contentsSiteReducer;
